
import { defineComponent } from 'vue';
import VInputSwitch from '@/components/vendor/basic/form/parts/VInputSwitch.vue';

export default defineComponent({
  name: 'VFormGroupInputSwitch',
  components: {
    VInputSwitch,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    forKey: {
      type: String,
      required: false,
      default: 'checkbox',
    },
    labelClass: {
      type: String,
      required: false,
      default: null,
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    yupErrorsVariable: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    emitValue(value) {
      this.$emit('update:value', value);
    },
  },
});
